import {AxiosInstance, AxiosRequestConfig} from 'axios'

import {ConfigurationName, FeatureFlag} from '../types'

export const getFeatureFlags =
  (api: AxiosInstance, configurationName: ConfigurationName) =>
  async (
    axiosConfig?: AxiosRequestConfig & {
      params?: Record<string, string | number | boolean | string[] | undefined>
    },
    signal?: AbortSignal
  ): Promise<FeatureFlag[]> => {
    const response = await api.get<FeatureFlag[]>(
      `/hproduce-feature-flags/${configurationName}/feature-flags`,
      {
        ...axiosConfig,
        params: {
          ...(axiosConfig?.params || {})
        },
        signal
      }
    )
    return response.data
  }
